import { render } from "./EventList.vue?vue&type=template&id=7d1860f6&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=7d1860f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d1860f6"

export default script